import * as React from 'react';

interface Props {
  color?: string;
}
export const Lock: React.SFC<Props> = ({ color = '#888888' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={`M4.02667 16.56C4.02667 20.6667 7.36 24 11.4667 24C15.5733 24 18.9067 20.64 18.9067 16.5333C18.9067 12.4267 15.5733 9.09334 11.4667 9.09334C7.36 9.09334 4.02667 12.4533 4.02667 16.56ZM5.36 16.5333C5.36 13.1733 8.08 10.4267 11.4667 10.4267C14.8533 10.4267 17.5733 13.2 17.5733 16.56C17.5733 19.92 14.8533 22.6667 11.4667 22.6667C8.08 22.6667 5.36 19.8933 5.36 16.5333Z`}
        fill="#A9A9A9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={`M16.56 12.5867C16.1867 12.5867 15.8933 12.2933 15.8933 11.92V5.76C15.8933 3.30667 13.8933 1.33333 11.4667 1.33333C9.04 1.33333 7.04 3.30667 7.04 5.76V11.9467C7.04 12.32 6.74667 12.6133 6.37333 12.6133C6 12.6133 5.70667 12.32 5.70667 11.9467V5.76C5.70667 2.58667 8.29333 0 11.4667 0C14.64 0 17.2267 2.58667 17.2267 5.76V11.9467C17.2267 12.2933 16.9333 12.5867 16.56 12.5867Z`}
        fill="#A9A9A9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={`M11.5 18.8182C12.7803 18.8182 13.8182 17.7803 13.8182 16.5C13.8182 15.2197 12.7803 14.1818 11.5 14.1818C10.2197 14.1818 9.18182 15.2197 9.18182 16.5C9.18182 17.7803 10.2197 18.8182 11.5 18.8182Z`}
        fill="#A9A9A9"
      />
    </svg>
  );
};
